// module
export * from './index';
// page-titles-service
export * from './services/page-titles.service';
// page-title-component
export * from './page-title-component/page-title.component';
